import React from "react";

export default function disabledInputs(components) {
  return disabled =>
    Object.entries(components).reduce(
      (enhanced, [name, C]) => ({
        ...enhanced,
        [name]: props => <C {...props} disabled={disabled} />
      }),
      {}
    );
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/disabledInputs.jsx